import { FEATURE_TOGGLE_DEFAULTS, type FeatureToggles } from '~/types/Internal/Setup/FeatureToggles';

function deepMerge<T extends object>(defaults: T, overrides: Partial<T>): T {
  const result = { ...defaults };

  for (const key in overrides) {
    const overrideVal = overrides[key];
    const defaultVal = defaults[key];

    if (
      overrideVal !== null &&
      typeof overrideVal === 'object' &&
      !Array.isArray(overrideVal) &&
      typeof defaultVal === 'object' &&
      defaultVal !== null
    ) {
      result[key] = deepMerge(defaultVal as object, overrideVal as Partial<object>) as T[typeof key];
    } else if (overrideVal !== undefined) {
      result[key] = overrideVal as T[typeof key];
    }
  }

  return result;
}

export function useFeatureToggles(): FeatureToggles {
  const config = useRuntimeConfig();
  const featureToggles = config.public.featureToggles as Partial<FeatureToggles>;

  return deepMerge(FEATURE_TOGGLE_DEFAULTS, featureToggles);
}
